/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

//==============================================================
// START Enums and Input Objects
//==============================================================

/**
 * An enumeration.
 */
export enum AccountErrorCode {
  ACCOUNT_NOT_CONFIRMED = "ACCOUNT_NOT_CONFIRMED",
  ACTIVATE_OWN_ACCOUNT = "ACTIVATE_OWN_ACCOUNT",
  ACTIVATE_SUPERUSER_ACCOUNT = "ACTIVATE_SUPERUSER_ACCOUNT",
  DEACTIVATE_OWN_ACCOUNT = "DEACTIVATE_OWN_ACCOUNT",
  DEACTIVATE_SUPERUSER_ACCOUNT = "DEACTIVATE_SUPERUSER_ACCOUNT",
  DELETE_NON_STAFF_USER = "DELETE_NON_STAFF_USER",
  DELETE_OWN_ACCOUNT = "DELETE_OWN_ACCOUNT",
  DELETE_STAFF_ACCOUNT = "DELETE_STAFF_ACCOUNT",
  DELETE_SUPERUSER_ACCOUNT = "DELETE_SUPERUSER_ACCOUNT",
  GRAPHQL_ERROR = "GRAPHQL_ERROR",
  INACTIVE = "INACTIVE",
  INVALID = "INVALID",
  INVALID_CREDENTIALS = "INVALID_CREDENTIALS",
  INVALID_PASSWORD = "INVALID_PASSWORD",
  JWT_DECODE_ERROR = "JWT_DECODE_ERROR",
  JWT_INVALID_CSRF_TOKEN = "JWT_INVALID_CSRF_TOKEN",
  JWT_INVALID_TOKEN = "JWT_INVALID_TOKEN",
  JWT_MISSING_TOKEN = "JWT_MISSING_TOKEN",
  JWT_SIGNATURE_EXPIRED = "JWT_SIGNATURE_EXPIRED",
  LEFT_NOT_MANAGEABLE_PERMISSION = "LEFT_NOT_MANAGEABLE_PERMISSION",
  NOT_FOUND = "NOT_FOUND",
  OUT_OF_SCOPE_GROUP = "OUT_OF_SCOPE_GROUP",
  OUT_OF_SCOPE_PERMISSION = "OUT_OF_SCOPE_PERMISSION",
  OUT_OF_SCOPE_USER = "OUT_OF_SCOPE_USER",
  PASSWORD_ENTIRELY_NUMERIC = "PASSWORD_ENTIRELY_NUMERIC",
  PASSWORD_TOO_COMMON = "PASSWORD_TOO_COMMON",
  PASSWORD_TOO_SHORT = "PASSWORD_TOO_SHORT",
  PASSWORD_TOO_SIMILAR = "PASSWORD_TOO_SIMILAR",
  REQUIRED = "REQUIRED",
  UNIQUE = "UNIQUE",
}

/**
 * An enumeration.
 */
export enum CountryCode {
  AD = "AD",
  AE = "AE",
  AF = "AF",
  AG = "AG",
  AI = "AI",
  AL = "AL",
  AM = "AM",
  AO = "AO",
  AQ = "AQ",
  AR = "AR",
  AS = "AS",
  AT = "AT",
  AU = "AU",
  AW = "AW",
  AX = "AX",
  AZ = "AZ",
  BA = "BA",
  BB = "BB",
  BD = "BD",
  BE = "BE",
  BF = "BF",
  BG = "BG",
  BH = "BH",
  BI = "BI",
  BJ = "BJ",
  BL = "BL",
  BM = "BM",
  BN = "BN",
  BO = "BO",
  BQ = "BQ",
  BR = "BR",
  BS = "BS",
  BT = "BT",
  BV = "BV",
  BW = "BW",
  BY = "BY",
  BZ = "BZ",
  CA = "CA",
  CC = "CC",
  CD = "CD",
  CF = "CF",
  CG = "CG",
  CH = "CH",
  CI = "CI",
  CK = "CK",
  CL = "CL",
  CM = "CM",
  CN = "CN",
  CO = "CO",
  CR = "CR",
  CU = "CU",
  CV = "CV",
  CW = "CW",
  CX = "CX",
  CY = "CY",
  CZ = "CZ",
  DE = "DE",
  DJ = "DJ",
  DK = "DK",
  DM = "DM",
  DO = "DO",
  DZ = "DZ",
  EC = "EC",
  EE = "EE",
  EG = "EG",
  EH = "EH",
  ER = "ER",
  ES = "ES",
  ET = "ET",
  FI = "FI",
  FJ = "FJ",
  FK = "FK",
  FM = "FM",
  FO = "FO",
  FR = "FR",
  GA = "GA",
  GB = "GB",
  GD = "GD",
  GE = "GE",
  GF = "GF",
  GG = "GG",
  GH = "GH",
  GI = "GI",
  GL = "GL",
  GM = "GM",
  GN = "GN",
  GP = "GP",
  GQ = "GQ",
  GR = "GR",
  GS = "GS",
  GT = "GT",
  GU = "GU",
  GW = "GW",
  GY = "GY",
  HK = "HK",
  HM = "HM",
  HN = "HN",
  HR = "HR",
  HT = "HT",
  HU = "HU",
  ID = "ID",
  IE = "IE",
  IL = "IL",
  IM = "IM",
  IN = "IN",
  IO = "IO",
  IQ = "IQ",
  IR = "IR",
  IS = "IS",
  IT = "IT",
  JE = "JE",
  JM = "JM",
  JO = "JO",
  JP = "JP",
  KE = "KE",
  KG = "KG",
  KH = "KH",
  KI = "KI",
  KM = "KM",
  KN = "KN",
  KP = "KP",
  KR = "KR",
  KW = "KW",
  KY = "KY",
  KZ = "KZ",
  LA = "LA",
  LB = "LB",
  LC = "LC",
  LI = "LI",
  LK = "LK",
  LR = "LR",
  LS = "LS",
  LT = "LT",
  LU = "LU",
  LV = "LV",
  LY = "LY",
  MA = "MA",
  MC = "MC",
  MD = "MD",
  ME = "ME",
  MF = "MF",
  MG = "MG",
  MH = "MH",
  MK = "MK",
  ML = "ML",
  MM = "MM",
  MN = "MN",
  MO = "MO",
  MP = "MP",
  MQ = "MQ",
  MR = "MR",
  MS = "MS",
  MT = "MT",
  MU = "MU",
  MV = "MV",
  MW = "MW",
  MX = "MX",
  MY = "MY",
  MZ = "MZ",
  NA = "NA",
  NC = "NC",
  NE = "NE",
  NF = "NF",
  NG = "NG",
  NI = "NI",
  NL = "NL",
  NO = "NO",
  NP = "NP",
  NR = "NR",
  NU = "NU",
  NZ = "NZ",
  OM = "OM",
  PA = "PA",
  PE = "PE",
  PF = "PF",
  PG = "PG",
  PH = "PH",
  PK = "PK",
  PL = "PL",
  PM = "PM",
  PN = "PN",
  PR = "PR",
  PS = "PS",
  PT = "PT",
  PW = "PW",
  PY = "PY",
  QA = "QA",
  RE = "RE",
  RO = "RO",
  RS = "RS",
  RU = "RU",
  RW = "RW",
  SA = "SA",
  SB = "SB",
  SC = "SC",
  SD = "SD",
  SE = "SE",
  SG = "SG",
  SH = "SH",
  SI = "SI",
  SJ = "SJ",
  SK = "SK",
  SL = "SL",
  SM = "SM",
  SN = "SN",
  SO = "SO",
  SR = "SR",
  SS = "SS",
  ST = "ST",
  SV = "SV",
  SX = "SX",
  SY = "SY",
  SZ = "SZ",
  TC = "TC",
  TD = "TD",
  TF = "TF",
  TG = "TG",
  TH = "TH",
  TJ = "TJ",
  TK = "TK",
  TL = "TL",
  TM = "TM",
  TN = "TN",
  TO = "TO",
  TR = "TR",
  TT = "TT",
  TV = "TV",
  TW = "TW",
  TZ = "TZ",
  UA = "UA",
  UG = "UG",
  UM = "UM",
  US = "US",
  UY = "UY",
  UZ = "UZ",
  VA = "VA",
  VC = "VC",
  VE = "VE",
  VG = "VG",
  VI = "VI",
  VN = "VN",
  VU = "VU",
  WF = "WF",
  WS = "WS",
  YE = "YE",
  YT = "YT",
  ZA = "ZA",
  ZM = "ZM",
  ZW = "ZW",
}

export enum OfferAttributeEnum {
  BENEFITS = "BENEFITS",
  BODY_TYPE = "BODY_TYPE",
  CARGO_TYPE = "CARGO_TYPE",
  COMPANY_SIZE = "COMPANY_SIZE",
  CREW_TYPE = "CREW_TYPE",
  CUSTOM = "CUSTOM",
  DRIVER = "DRIVER",
  DRIVER_LICENSE = "DRIVER_LICENSE",
  EMPLOYMENT = "EMPLOYMENT",
  EXPERIENCE = "EXPERIENCE",
  FLEET = "FLEET",
  LANGUAGES = "LANGUAGES",
  LOCALIZATION = "LOCALIZATION",
  OPERATION = "OPERATION",
  PERMISSIONS = "PERMISSIONS",
  SPECIFICATION = "SPECIFICATION",
  TRANSPORT = "TRANSPORT",
  TRANSPORT_DIRECTIONS = "TRANSPORT_DIRECTIONS",
  VEHICLE_TYPE = "VEHICLE_TYPE",
  WORK_SYSTEM = "WORK_SYSTEM",
}

/**
 * An enumeration.
 */
export enum OfferErrorCode {
  ACTIVE = "ACTIVE",
  ATTRIBUTE_NON_MULTI = "ATTRIBUTE_NON_MULTI",
  INACTIVE = "INACTIVE",
  INVALID = "INVALID",
  INVALID_ADDRESS = "INVALID_ADDRESS",
  INVALID_ATTRIBUTES = "INVALID_ATTRIBUTES",
  INVALID_CHOICES = "INVALID_CHOICES",
  NOT_FOUND = "NOT_FOUND",
  REQUIRED = "REQUIRED",
}

/**
 * An enumeration.
 */
export enum OfferFiltersEnum {
  BENEFITS = "BENEFITS",
  BODY_TYPE = "BODY_TYPE",
  CARGO_TYPE = "CARGO_TYPE",
  COMPANY_SIZE = "COMPANY_SIZE",
  CREW_TYPE = "CREW_TYPE",
  DRIVER = "DRIVER",
  DRIVER_LICENSE = "DRIVER_LICENSE",
  EMPLOYMENT = "EMPLOYMENT",
  EXPERIENCE = "EXPERIENCE",
  FLEET = "FLEET",
  LANGUAGES = "LANGUAGES",
  LOCALIZATION = "LOCALIZATION",
  OPERATION = "OPERATION",
  PERMISSIONS = "PERMISSIONS",
  SPECIFICATION = "SPECIFICATION",
  TRANSPORT = "TRANSPORT",
  TRANSPORT_DIRECTIONS = "TRANSPORT_DIRECTIONS",
  VEHICLE_TYPE = "VEHICLE_TYPE",
  WORK_SYSTEM = "WORK_SYSTEM",
}

/**
 * An enumeration.
 */
export enum PaymentErrorCode {
  INVALID_BILLING_DATA = "INVALID_BILLING_DATA",
  MISSING_CUSTOMER = "MISSING_CUSTOMER",
  MISSING_ORDER = "MISSING_ORDER",
  MISSING_OR_INVALID_RETURN_URL = "MISSING_OR_INVALID_RETURN_URL",
  MISSING_PAYMENT_SOURCE = "MISSING_PAYMENT_SOURCE",
  PROCESSING_FAILURE = "PROCESSING_FAILURE",
}

export enum PaymentMethodEnum {
  PRZELEWY24 = "PRZELEWY24",
}

export interface AccountRegisterInput {
  email: string;
  password: string;
  firstName: string;
  lastName: string;
  companyName?: string | null;
}

export interface ApplicationCreateInput {
  offer: string;
  email: string;
  fullName: string;
  cv?: any | null;
  consentAccept: boolean;
  adr: boolean;
  driverCard: boolean;
  experience: string;
  direction: string;
  phoneNumber: string;
}

export interface AttributeInput {
  slug: string;
  value: string;
}

export interface BillingAddressInput {
  address: string;
  city: string;
  companyName?: string | null;
  email: string;
  firstName?: string | null;
  isCompany: boolean;
  lastName?: string | null;
  phone?: string | null;
  postalCode: string;
  taxId?: string | null;
}

export interface LineInput {
  offerId: string;
  productId: string;
}

export interface OfferAddressInput {
  city: string;
  countryCode: CountryCode;
  lat: number;
  lng: number;
  postalCode: string;
  province: string;
  streetAddress: string;
}

export interface OfferAttestationInput {
  regulationAccepted: boolean;
  marketingConsentAccepted: boolean;
}

export interface OfferAttributeInput {
  slug: string;
  values: (string | null)[];
}

export interface OfferFilterInput {
  attributes?: (AttributeInput | null)[] | null;
  salaryFrom?: number | null;
  salaryTo?: number | null;
  search?: string | null;
}

export interface OfferInput {
  address: OfferAddressInput;
  attributes: (OfferAttributeInput | null)[];
  companyDescription: any;
  companyName: string;
  companySite: string;
  email: string;
  logo: any;
  taborImage?: any | null;
  offerDescription: any;
  salaryFrom: any;
  salaryTo: any;
  title: string;
}

export interface PasswordSetInput {
  uid: string;
  token: string;
  password: string;
}

export interface PaymentInput {
  paymentMethod: PaymentMethodEnum;
  token?: string | null;
  billingAddress: BillingAddressInput;
  lines: LineInput[];
  returnUrl?: string | null;
}

//==============================================================
// END Enums and Input Objects
//==============================================================
